module.exports = __webpack_public_path__ + "static/media/tmdb.adc0eec2.svg";